let error = null
let notification = null
export default {
    error,
    notification
}